class FailRequest extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    this.innerHTML = `
      <div class="page-fail">
      <p>Something's wrong. Please try again later...</p>
    </div>
        `;
  }
}

customElements.define('fail-request', FailRequest);
